module.exports = {"Diagrams":"Diagrams"}